import {
    type AlignProposalPayload,
    type AlignProposalResponse,
    alignProposalResponseSchema,
} from '@repo/types/align-proposal';
import { fetcher } from '@repo/utils';

import { type ServicesBasePath } from './services.utils';

export interface AlignProposalQueryParams {
    country: string;
    buCode: string;
    zipCode: string;
}

export const getAlignProposal = async (
    servicesBasePath: ServicesBasePath,
    payload: AlignProposalPayload,
    queryParams: AlignProposalQueryParams
): Promise<AlignProposalResponse> => {
    const searchParams = new URLSearchParams({ zipCode: queryParams.zipCode });
    const url = `${servicesBasePath}/order-promise/centiro/align-proposal/${queryParams.country.toUpperCase()}/${queryParams.buCode}?${searchParams.toString()}`;
    const response = await fetcher(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json',
            'x-centiro-v2-enabled': 'true',
        },
    });
    const data = await response.json();
    return alignProposalResponseSchema.parse(data);
};
